import React from 'react';
import { TableCellProps } from '../../../types/search';
import ImagesModal from './ImagesModal';
import AttachmentsModal from './AttachmentsModal';

export default function PortalCellAttachments({ row, listingType }: Readonly<TableCellProps>) {
  return (
    <div className="portal-cell--attachments">
      <div className="portal-cell__trigger-btns-wrap">
        <ImagesModal row={row} listingType={listingType} />
        <AttachmentsModal row={row} listingType={listingType} />
      </div>
    </div>
  );
}
